export default "__VITE_ASSET__zi_wT0ly__"